import React, { PureComponent } from "react";
import { PropTypes } from "prop-types";
import { Modal, Header, Button, Icon, Label } from "semantic-ui-react";

import { AUTH_INACTIVITY_WARNING_TIMEOUT } from "../../constants/authenticationConstants.js";

class InactivityModal extends PureComponent {
  static propTypes = {
    onClose: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    copy: PropTypes.object.isRequired
  };

  state = {
    sidebarVisible: true,
    count: AUTH_INACTIVITY_WARNING_TIMEOUT * 0.001,
    countInterval: null
  };

  componentDidMount() {
    this.setState({
      countInterval: setInterval(this.updateCountdown, 1000)
    });
  }

  componentWillUnmount() {
    const { countInterval } = this.state;
    clearInterval(countInterval);
  }

  updateCountdown = () => {
    const { onClose } = this.props;
    const { count, countInterval } = this.state;

    const newCount = count - 1;

    this.setState({ count: newCount });

    if (newCount <= 0) {
      clearInterval(countInterval);
      onClose(false);
    }
  };

  closeHandler = evt => {
    const { onClose } = this.props;
    // using dataset rather than bind to reduce renders
    const confirmed = evt.target.dataset.confirmed === "true";
    onClose(confirmed);
  };

  render() {
    const { copy, open } = this.props;
    const { count } = this.state;

    return (
      <Modal open={open} closeOnDimmerClick={false}>
        <Header icon="exclamation circle" content={copy.title} />
        <Modal.Content>
          <p>{copy.message}</p>
          <Label circular color="red" size="huge">
            {count}
          </Label>
        </Modal.Content>
        <Modal.Actions>
          <Button
            color="red"
            data-confirmed="false"
            onClick={this.closeHandler}
          >
            <Icon name="remove" /> {copy.no}
          </Button>
          <Button
            color="green"
            data-confirmed="true"
            onClick={this.closeHandler}
          >
            <Icon name="checkmark" /> {copy.yes}
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

export default InactivityModal;
